import { FullSizeSpinner } from '@/components/full-size-spinner';
import { PageWrapper } from '@/components/page-wrapper/page-wrapper';
import { Container } from '@lego/klik-ui';
import { type ReactElement, useRef, useState } from 'react';
import { useSimulationList } from '../simulation-queries';
import { useSimulationQueryErrorNotification } from '../use-simulation-query-error-notification';
import { EmptyListAction } from './components/empty-list';
import SimulationList from './components/list/simulation-list';
import { NewSimulationModal } from './components/start-sim-modal/new-simulation-modal';

export const SIMULATION_LIST_QUERY_KEY = 'simulationList';

export const SimulationListPage = (): ReactElement => {
  const [showStartSimModal, setShowStartSimModal] = useState(false);
  const newSimulationTriggerRef = useRef<HTMLButtonElement | null>(null);

  const {
    data: simulationListData,
    isPending: isFetchingSimulations,
    isError: isSimulationListError,
    error: simulationListError,
  } = useSimulationList();

  useSimulationQueryErrorNotification({
    isError: isSimulationListError,
    error: simulationListError,
    title: 'Failed to load simulation list',
  });
  return (
    <PageWrapper
      headerProps={{
        title: 'Simulations',
      }}
      layout="fill"
      maxWidth="100%"
      contentPaddingX={0}
    >
      <Container maxW="100%" padding={0} height="100%" minHeight={0}>
        {isFetchingSimulations ? (
          <FullSizeSpinner />
        ) : simulationListData && simulationListData.length > 0 ? (
          <SimulationList
            onNewSimulationClick={() => setShowStartSimModal(true)}
            newSimulationTriggerRef={newSimulationTriggerRef}
            data={simulationListData ?? []}
            isLoading={isFetchingSimulations}
          />
        ) : (
          <EmptyListAction
            onNewSimulationClick={() => setShowStartSimModal(true)}
            newSimulationTriggerRef={newSimulationTriggerRef}
          />
        )}
      </Container>
      <NewSimulationModal
        isOpen={showStartSimModal}
        onClose={() => setShowStartSimModal(false)}
        triggerRef={newSimulationTriggerRef}
      />
    </PageWrapper>
  );
};
